import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, BookOpenIcon, ChevronRightIcon } from 'lucide-react';
export function QuickLinks() {
  return <div className="w-full pb-12 md:pb-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2540">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2541">
        <h2 className="text-xl font-bold uppercase mb-5" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2542">
          Related Links
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-2543">
          <Link to="/" className="flex items-center gap-3 p-4 rounded-xl bg-white border shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 group" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2544">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors group-hover:bg-[#1e3d2f]" style={{
            backgroundColor: 'rgba(30,61,47,0.06)'
          }} data-id="element-2545">
              <HomeIcon size={18} className="transition-colors group-hover:text-white" style={{
              color: '#1e3d2f'
            }} data-id="element-2546" />
            </div>
            <span className="font-semibold text-sm" style={{
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2547">
              Home
            </span>
          </Link>

          <Link to="/ConstitutionAndByLaws.html" className="flex items-center gap-3 p-4 rounded-xl bg-white border shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 group" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2548">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors group-hover:bg-[#1e3d2f]" style={{
            backgroundColor: 'rgba(30,61,47,0.06)'
          }} data-id="element-2549">
              <BookOpenIcon size={18} className="transition-colors group-hover:text-white" style={{
              color: '#1e3d2f'
            }} data-id="element-2550" />
            </div>
            <span className="font-semibold text-sm" style={{
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2551">
              Constitution
            </span>
          </Link>

          <Link to="/ContactUs.html" className="flex items-center gap-3 p-4 rounded-xl bg-white border shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5 group" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2552">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors group-hover:bg-[#1e3d2f]" style={{
            backgroundColor: 'rgba(30,61,47,0.06)'
          }} data-id="element-2553">
              <ChevronRightIcon size={18} className="transition-colors group-hover:text-white" style={{
              color: '#1e3d2f'
            }} data-id="element-2554" />
            </div>
            <span className="font-semibold text-sm" style={{
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2555">
              Contact Us
            </span>
          </Link>
        </div>
      </div>
    </div>;
}